import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';

import { SourceFormationModel } from '../models/SourceFormationModel';
import { TypeMediaModel } from '../models/TypeMediaModel';

import { SessionFormationApiService } from '../web-api-services/sessionformation.service';
import { MediaApiService } from '../web-api-services/media.service';
import { AideModel } from '../models/AideModel';
import { CommonApiService } from '../web-api-services/common.service';
import { EtablissementApiService } from '../web-api-services/etablissement.service';
import { EtablissementSiteIndicateurModel } from '../models/EtablissementSiteIndicateurModel';
import { IndicateurModel } from '../models/IndicateurModel';
import { UtilisateurApiService } from '../web-api-services/utilisateur.service';
import { IdNomOrdreModel } from '../models/IdNomOrdreModel';
import { FormationContinueApiService } from '../web-api-services/formationcontinue.service';
import { IdNomModel } from '../models/IdNomModel';
import { CategorieHierarchiqueModel } from '../models/CategorieHierarchiqueModel';
import { StatutEmploiModel } from '../models/StatutEmploiModel';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  constructor(
    private sessionFormationApiService: SessionFormationApiService,
    private mediaApiService: MediaApiService,
    private commonApiService: CommonApiService,
    private etablissementApiService: EtablissementApiService,
    private utilisateurApiService: UtilisateurApiService,
    private formationContinueApiService: FormationContinueApiService
  ) {}

  getSourceFormations(): Observable<SourceFormationModel[]> {
    return this.getGenerics<SourceFormationModel>('sourceformations', this.sessionFormationApiService.getSourceFormations());
  }

  getIndicateurs(): Observable<IndicateurModel[]> {
    return this.getGenerics<IndicateurModel>('indicateurs', this.commonApiService.getIndicateurs());
  }

  getFonctions(): Observable<IdNomOrdreModel[]> {
    return this.getGenerics<IdNomOrdreModel>('indicateurs', this.utilisateurApiService.getFonctions());
  }

  getTypeMedia(id: number): Observable<TypeMediaModel> {
    return this.getGenericsWithParameter<TypeMediaModel>('typemedia', id, this.mediaApiService.getTypeMedia(id));
  }

  getAides(): Observable<AideModel[]> {
    return this.getGenerics('aides', this.commonApiService.getAides());
  }

  getEtablissementsSiteIndicateur(): Observable<EtablissementSiteIndicateurModel[]> {
    return this.getGenerics('etablissementsSiteIndicateur', this.etablissementApiService.getEtablissementsSiteIndicateur());
  }

  clearEtablissementsSiteIndicateur(): void {
    this.clearGenerics('etablissementsSiteIndicateur');
  }

  getTypeActions(): Observable<IdNomModel[]> {
    return this.getGenerics<IdNomModel>('typeactions', this.formationContinueApiService.getTypeActions());
  }

  getCategorieHierarchiques(): Observable<CategorieHierarchiqueModel[]> {
    return this.getGenerics<CategorieHierarchiqueModel>('categoriehierarchiques', this.formationContinueApiService.getCategorieHierarchiques());
  }

  getStatutEmplois(): Observable<StatutEmploiModel[]> {
    return this.getGenerics<StatutEmploiModel>('statutemplois', this.formationContinueApiService.getStatutEmplois());
  }

  private clearGenerics(key: string): void {
    this.generics[key] = null;
  }

  private genericsSimple: any[] = [];
  private genericsSimpleObservable: Observable<any[]>[] = [];
  private getGenericsSimple<T>(key: string, method: Observable<T>): Observable<T> {
    if (this.genericsSimple[key]) {
      return of(this.genericsSimple[key]);
    } else if (this.genericsSimpleObservable[key] == null) {
      this.genericsSimpleObservable[key] = method.pipe(
        share(),
        map((generics) => {
          this.genericsSimple[key] = generics;
          return generics;
        })
      );
    }
    return this.genericsSimpleObservable[key];
  }

  private generics: any[][] = [];
  private genericsObservable: Observable<any[]>[] = [];
  private getGenerics<T>(key: string, method: Observable<T[]>): Observable<T[]> {
    if (this.generics[key]) {
      return of(this.generics[key]);
    } else if (this.genericsObservable[key] == null) {
      this.genericsObservable[key] = method.pipe(
        share(),
        map((generics) => {
          this.generics[key] = generics;
          return generics;
        })
      );
    }
    return this.genericsObservable[key];
  }

  private genericsObservableWithParameter: Observable<any>[][] = [];
  private getGenericsWithParameter<T>(key: string, key2: number | string, method: Observable<T>): Observable<T> {
    if (!this.generics[key]) {
      this.generics[key] = [];
    }
    if (!this.genericsObservableWithParameter[key]) {
      this.genericsObservableWithParameter[key] = [];
    }
    if (this.generics[key] && this.generics[key][key2] != null) {
      return of(this.generics[key][key2]);
    } else if (this.genericsObservableWithParameter[key][key2] == null) {
      this.genericsObservableWithParameter[key][key2] = method.pipe(
        share(),
        map((generics) => {
          this.generics[key][key2] = generics;
          return generics;
        })
      );
    }
    return this.genericsObservableWithParameter[key][key2];
  }
}
